var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"u-only--pc switch-by-ua",domProps:{"innerHTML":_vm._s(_vm.content.contentForPc)}}),_vm._v(" "),_c('div',{staticClass:"u-only--sp switch-by-ua",domProps:{"innerHTML":_vm._s(_vm.content.contentForMobile)}})])}
var staticRenderFns = []

export { render, staticRenderFns }